import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-one-column-title-button',
  templateUrl: './footer-one-column-title-button.component.html',
  styleUrls: ['./footer-one-column-title-button.component.scss']
})
export class FooterOneColumnTitleButtonComponent implements OnInit {

    @Input() title: any = '';
    @Input() subtitle: any = '';
    @Input() button: any = '';
    @Input() url: any = '';
    @Input() width: any = '';

    constructor() { }

    ngOnInit(): void {
    }

}
